// extracted by mini-css-extract-plugin
export var animationContainer = "_ov-0";
export var footer = "_ov-1";
export var gray = "_ov-2";
export var lineItem = "_ov-3";
export var lineItemImage = "_ov-4";
export var lineItemInfo = "_ov-5";
export var lineItemText = "_ov-6";
export var lineItems = "_ov-7";
export var modalContent = "_ov-8";
export var options = "_ov-9";
export var orderName = "_ov-a";
export var refundAmount = "_ov-b";